{
  "app": {
    "logoTitle": "Faculty Leave",
    "logoSubtitle": "",
    "description": "Application to enter and track Sabbatical and Professional Development leave for Stanford faculty",
    "copyrightYear": "2026",
    "supportEmail": "som-leaves@stanford.edu"
  },
  "globals": {
    "labels": {
      "sunetID": "SUNet ID",
      "actions": "Links",
      "categorySAB": "SAB",
      "categoryPDL": "PDL",
      "effectiveDate": "Effective Date"
    },
    "list": {
      "messages": {
        "noData": "No records to display",
        "fetchingInfo": "Fetching data ...",
        "dataLoadingText": "Loading ..."
      }
    },
    "form": {
      "actionButtons": {
        "ok": "OK",
        "save": "SAVE",
        "cancel": "CANCEL",
        "yes": "YES",
        "no": "NO",
        "close": "CLOSE",
        "dismiss": "DISMISS",
        "send": "SEND",
        "expandAll": "EXPAND ALL",
        "collapseAll": "COLLAPSE ALL",
        "leaveSectionNotesBtn": "EDIT LEAVE SECTION NOTES"
      },
      "dateValidationMessages": {
        "startDateValidation": "The Start Date cannot be later than the End Date.",
        "endDateValidation": "The End Date cannot be earlier than the Start Date.",
        "invalidDateFormat": "Invalid Date Format."
      }
    }
  },
  "FLA": {
    "mainView": {
      "title": "Faculty List",
      "list": {
        "tableColumns": {
          "name": "Name",
          "rank": "Rank",
          "line": "Line",
          "department": "Department",
          "apptStart": "Appt Start",
          "apptEnd": "Appt End",
          "actions": "Links"
        },
        "tooltips": {
          "actions": {
            "text": "View Faculty Details"
          },
          "name": {
            "text": {
              "universityID": "University ID",
              "sunetID": "SUNet ID"
            }
          }
        }
      }
    },
    "filterPanel": {
      "title": "Filters",
      "options": {
        "person": {
          "label": "Person"
        },
        "department": {
          "label": "Department"
        },
        "division": {
          "label": "Division"
        },
        "line": {
          "label": "Line of Appointment"
        },
        "activeInactive": {
          "label": "Active / Inactive",
          "active": "Active",
          "inactive": "Inactive"
        },
        "category": {
          "label": "Primary Appt. Category"
        }
      },
      "resetFilterText": "Reset All Filters",
      "clearFilterText": "Clear All Filters"
    }
  },
  "LeaveAccruedTaken": {
    "breadcrumb": {
      "facultyListLabel": "Faculty List",
      "leaveAccruedLabel": "Leave Accrued - Taken"
    },
    "facultyDetailsLabels": {
      "prefName": "Preferred Name",
      "universityId": "University ID",
      "yearsInRank": "Years in Rank",
      "yearsInRankObject": {
        "INACTIVE": "Inactive",
        "NA": "N/A"
      },
      "yearMonthObject": {
        "year": "{{count}} year",
        "year_plural": "{{count}} years",
        "month": "{{count}} month",
        "month_plural": "{{count}} months"
      },
      "averageFTE": "Average FTE last 3 years",
      "averageFTEHelpText": "This average counts only days of PDL appointments.",
      "academicApptDate": "Academic Appt. Date",
      "fiveYrServiceReqMet": "Five Year Service Requirement Met",
      "fiveYrServiceReqAlert": {
        "FUTURE": "Future",
        "GAP": "Gap"
      }
    },
    "currentApptLabels": {
      "currentApptsTitle": "Current Appointments > 0% FTE",
      "primary": "Primary",
      "apptFTE": "Appointment FTE",
      "department": "Department",
      "division": "Division",
      "rank": "Rank",
      "line": "Line",
      "apptStart": "Appt Start",
      "apptEnd": "Appt End",
      "school": "School",
      "schoolTooltipText": "> 0% of current FTE is outside the School of Medicine"
    },
    "apptHistoryLabels": {
      "apptHistoryTitle": "Appointment History",
      "fte": "FTE",
      "department": "Department",
      "rank": "Rank",
      "line": "Line",
      "apptStart": "Appt Start",
      "apptEnd": "Appt End"
    },
    "leaveHistoryLabels": {
      "leaveTitle": "Leave",
      "leaveDataSource": "Data Source",
      "leaveType": "Leave Type",
      "leaveStart": "Leave Start",
      "leaveEnd": "Leave End",
      "percOnDuty": "Percentage on Duty",
      "actionId": "Action ID",
      "actionState": "Action State",
      "createLeaveActionButtonLabel": "Create Leave Action",
      "startDateGreaterThanEndDateWarning": "This is not being included in Accrual Calculation, because the Start Date and End Date are out of order.",
      "leaveSectionNotesTitle": "Leave Section Notes"
    },
    "leaveActionForm": {
      "newLeaveActionTitle": "New Leave Action",
      "editLeaveActionTitle": "Edit Leave Action",
      "viewLeaveActionTitle": "View Leave Action",
      "stateLabels": {
        "currentState": "Current State",
        "nextState": "Next State",
        "draftState": "Draft",
        "deptOaaReviewState": "Dept/OAA Review",
        "centralOfficesReviewState": "Central Offices Review",
        "withdrawnState": "Withdrawn",
        "deptOaaDeniedState": "Dept/OAA Denied",
        "finallyApprovedState": "Finally Approved",
        "finallyDeniedState": "Finally Denied"
      },
      "startDateLabel": "Start Date",
      "endDateLabel": "End Date",
      "applicationDocumentFieldLabel": "Application Document",
      "leaveActionNotesFieldLabel": "Leave Action Notes",
      "notificationRemarksFieldLabel": "Notification Remarks",
      "percentageOnDutyLabel": "Percentage on Duty",
      "accrualBegBalanceLabel": "Accrual Beg. Balance",
      "leaveTakenLabel": "Leave Taken",
      "accrualEndBalanceLabel": "Accrual End. Balance",
      "projectedStartDateLabel": "Projected as of Start Date",
      "projectedEndDateLabel": "Projected as of End Date",
      "leavePercentageIncreaseLabel": "Leave % Increase as per Average FTE last 3 years",
      "messages": {
        "percentageOnLeaveErrorMessage": "Enter a percentage between 0 and 99.999",
        "saveConfirmationMessage": "You are about to save this {{category}} Leave Action and put it in the {{nextState}} state. Are you sure?",
        "cancelConfirmationMessage": "You are about to discard this draft Leave Action. Are you sure?",
        "applicationURLValidationMsg": "The Application Document should be a proper URL.",
        "incorrectLeaveTypeMsg": "Incorrect Leave Type for Appointment.",
        "outsideAppointmentMsg": "Leave Dates are outside of the Appointment.",
        "duplicateLeaveMsg": "Duplicate Leave Request.",
        "percentageToUseErrorMsg": "Check your entries to be sure that the resulting net Percentage on Leave is within the range of 0% through 100%."
      },
      "leavePercentageIncreaseTooltipText": "The value entered here will be added to the calculated Percentage on Leave, to compensate for recent decline in the appointment FTE%.",
      "tooltipText": "This faculty member has some current appointment FTE percentage outside the School of Medicine. The FLA Admin adjusts the Percentage on Leave accordingly.",
      "averageFTELast3Years": "Average FTE last 3 years: {{percentageFTE}}",
      "emailNotification": {
        "emailNotificationTitle": "Email Notification",
        "toLabel": "To",
        "ccLabel": "Cc",
        "bccLabel": "Bcc",
        "subjectLabel": "Subject",
        "bodyLabel": "Body"
      },
      "leaveValidationMessage": {
        "OVRLP": "The date range overlaps an existing Leave record.",
        "OVRLP_FL": "Cannot overlap two PDL or two SAB leave records. A leave record exists from {{startDate}} to {{endData}} at {{percentageOnDuty}}% FTE.",
        "OVRLP_ML": "Cannot overlap two PDL or two SAB leave records. A leave record exists from {{startDate}} to {{endData}} at {{percentageOnDuty}}% FTE.",
        "PTUOOB": "Percentage on duty / Leave % increase out of range",
        "NOAPPT": "Faculty has no accrual for the given leave type or during the leave period."
      }
    },
    "appointmentSegmentsLabels": {
      "appointmentSegmentsTitle": "Appointment Segments",
      "category": "Category",
      "startDate": "Start",
      "endDate": "End",
      "somFte": "SoM FTE",
      "SAB": "Sabbatical",
      "PDL": "Professional Development Leave",
      "NA": "No Accrual",
      "NORMAL": "Milestone",
      "INDIVIDUAL": "Indiv.",
      "dailyAccrual": "Daily Accrual",
      "tooltip": {
        "dailyAccrual": {
          "text": "Days of leave accrued per day on duty at 100% FTE"
        }
      },
      "maxAccrual": "Max Accrual",
      "messages": {
        "incorrectLeaveType": "Leave Type invalid for Appointment Segment.",
        "duplicateMilestone": "Milestone already exists for Milestone Date.",
        "noAccrualPeriod": "Milestone Date in a No Accrual Period.",
        "beyondCurrentAppointment": "Milestone Date beyond Current Appointment."
      }
    },
    "accrualLabels": {
      "accrualTitle": "Accrual",
      "apptSegments": "Appt. Segments",
      "sabbatical": "SABBATICAL",
      "pdl": "PDL",
      "lwos": "LWOS",
      "loa": "CE-LOA",
      "jan": "Jan",
      "feb": "Feb",
      "mar": "Mar",
      "apr": "Apr",
      "may": "May",
      "jun": "Jun",
      "jul": "Jul",
      "aug": "Aug",
      "sep": "Sep",
      "oct": "Oct",
      "nov": "Nov",
      "dec": "Dec",
      "tooltipTexts": {
        "tooltipDataText": "Notes / comments from Box {{filename}}."
      },
      "beginningBalance": "Beg. Balance",
      "accrued": "Accrued",
      "taken": "Taken",
      "endBalance": "End. Balance",
      "noAccrualMessage": "There was no accrual in this year.",
      "accrualAdjustmentDialog": {
        "title": " {{category}} Accrual Adjustment",
        "impNote": "The sequence of steps to modify Accrual Balances is important!",
        "existingBegBalance": "Existing Beg. Balance",
        "resultingBegBalance": "Resulting Beg. Balance",
        "adjustTypeAdd": "Add",
        "adjustTypeSubtract": "Subtract",
        "adjustValue": "Days",
        "existingEndBalance": "Existing End. Balance",
        "newEndBalance": "New End. Balance",
        "accrualAdjustmentNotes": "Accrual Adjustment Notes",
        "helpIconTooltipInitialText": "FLA recalculates the balances in the Accrual section each time you Save either an Accrual Adjustment or an Individual Milestone. Use an Individual Milestone to set the Daily Accrual and Max Accrual. Use this panel to adjust Accrual. Set the Individual Milestone(s) first. Then do any necessary Accrual Adjustment(s). Work from the past toward the future. You can inspect the Accrual section as you go, to see what is happening.",
        "helpIconTooltipText": "You must enter an Effective Date (the first of a month) within the range of Appointment History. You must enter number of days to Add or Subtract. This number may be zero or a number with a decimal fraction. Each time FL recalculates, as it goes across the Effective Date, it will add or subtract the number of days you enter.",
        "saveConfirmationMsg": "You are about to save this Accrual Adjustment Transaction and recalculate Accrual from this Adjustment Effective date forward. Are you sure?",
        "effectiveDateValidationMsg": "Effective date out of Appointment range."
      }
    },
    "auditLabels": {
      "auditTitle": "Audit",
      "role": "Role",
      "date": "When",
      "action": "Verb",
      "category": "Category",
      "changeObject": "Object",
      "description": "Description"
    },
    "individualMilestoneForm": {
      "addIndividualMilestoneLabel": "Add Individual Milestone",
      "milestoneDate": "Milestone Date",
      "chooseIndividualMilestone": "Choose Individual Milestone",
      "identifier": "Identifier",
      "dailyAccrual": "Daily Accrual @100% FTE",
      "individualMilestoneNotes": "Individual Milestone Notes",
      "cancelConfirmationMsg": "You are about to discard your work on this Individual Milestone. Are you sure?",
      "saveConfirmationMsg": "You are about to put this Individual Milestone in Appointment Segments and recalculate Accrual from this Milestone Date forward. Are you sure?",
      "editIndividualMilestoneLabel": "Edit Individual Milestone",
      "viewIndividualMilestoneLabel": "View Individual Milestone",
      "editSaveConfirmationMsg": "Save your Individual Milestone Notes?",
      "removeMsgTitle": "Remove Individual Milestone",
      "removeMsg": "You are about to remove this Individual Milestone from Appointment Segments and recalculate Accrual from the previous Milestone Date forward. Are you sure?",
      "returnToNormalTooltipText": "Return to Normal will set Daily Accrual and Max. Accrual back to their values as of the previous normal (not individual) Milestone."
    }
  }
}